import { useEffect, useMemo, useRef, useState } from "react";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { useLocation, useParams, useHistory } from "react-router-dom";
import { AppTester, getCurrentAppName, getCurrentContextName } from "../../../supporting";
import { ExternalLink, FlexBox, useBreakpoint } from "@brg/ui";
import useQueryState from "shared/hooks/useQueryState";
import { API, Endpoints } from "@brg/api";
import {
  Arrow,
  LegalBlocksNew,
  LegalBlocks,
  Routes,
  Tab,
  PrevVersion,
  TiptapContainer,
  DocumentContent,
  LegalsHeader,
  DocumentWrapper,
  LegalsSubHeader,
  VersionRow
} from "./styles";
import VerticalNavigationArray from "shared/pages/LegalsPage/VerticalNavigationArray";
import moment from "moment";
import { LayoutConst } from "core";
import { BackButton } from "./styles";
import { ReactComponent as BackIcon } from "./icons/back.svg";
import { getTitle } from './documentHelper';
import { getText } from './documentHelper';

const LegalsPage = (props: any) => {

  const { t, i18n: { language } } = useTranslation();

  const theme = useTheme();
  const [target, setTarget] = useState<string | undefined>("");

  const history = useHistory();
  const location = useLocation();
  const isMobile = useBreakpoint(LayoutConst.screen.s);

  const [documents, setDocuments] = useState<ILegalDocument[]>([]);
  const [selectedDocument, setSelectedDocument] = useState<ILegalDocument | null>(null);

  const appName = getCurrentAppName();
  const contextName = AppTester.isMediiia() && !AppTester.isMediiiaMain() && !AppTester.isLectureMediiia()
    ? 'mediiia'
    : getCurrentContextName();

  const { name } = useParams<{ name: string }>();

  useEffect(() => {
    if (documents && (name || !isMobile)) {
      const d = documents.find((d) => d.name?.toLowerCase() === name?.toLowerCase()) ?? documents.find(d => !d.link) ?? null
      setSelectedDocument(d);
      setTarget(getTitle(d?.title, language) ?? getTitle(documents.at(0)?.title, language));
    }
  }, [name, documents, location, isMobile]);

  useEffect(() => {
    if (appName && contextName) {
      API.request()
        .endpoint(Endpoints.legal)
        .url("/api/Document/GetLegalDocuments")
        .get()
        .addQuery("appName", appName)
        .addQuery("contextName", contextName)
        .send()
        .then((r) => r.json())
        .then((r) => {
          if (r.length > 0) {
            setDocuments(r);
            if (!isMobile) {
              setSelectedDocument(r[0]);
            }
          }
        })
        .catch((e) => console.error(e));
    }
  }, [appName, contextName]);

  const onDocumentSelected = (doc: NavItem) => {
    if (doc.link) {
      window.open(`${doc.link}`, "_blank");
      return;
    }

    setTarget(getTitle(doc.title, language));
    setSelectedDocument(doc);
  };

  const onBackClick = () => {
    history.push("/legals");
    setSelectedDocument(null);
  };

  const shouldHideDocument = isMobile && !name;
  const shouldHideNavigation = isMobile && name;

  return (
    <TiptapContainer directionMobile="column">
      <DocumentWrapper>
        {!shouldHideNavigation && (
          <>
            {isMobile && <LegalsHeader>{t("legals.index")}</LegalsHeader>}
            <Tab theme={theme}>
              <VerticalNavigationArray
                items={documents}
                currentlySelectedKey={selectedDocument?.name}
                getKeyProp={(item) => item.name}
                getDisplayProp={(item) => getTitle(item.title, language)}
                onClick={onDocumentSelected}
              />
            </Tab>
          </>
        )}
        {!shouldHideDocument && (
          <LegalBlocksNew theme={theme}>
            {isMobile && (
              <BackButton onClick={onBackClick}>
                <BackIcon />
                <span>
                  {t("legals.all_documents")}
                </span>
              </BackButton>
            )}
            <DocumentContent dangerouslySetInnerHTML={{ __html: getText(selectedDocument?.text, language) ?? '' }} />
            <DocumentContent>
              {selectedDocument?.previousVersions?.[0] && (
                <FlexBox direction="column">
                  {/* <LegalsHeader>{t("legals.admin.version_history")}</LegalsHeader> */}
                  <LegalsSubHeader>{t("legals.admin.previous_versions")}</LegalsSubHeader>
                  <VersionRow>
                    <PrevVersion>{t("legals.admin.version_date")}:</PrevVersion>
                    <PrevVersion>{moment(selectedDocument.datePublished).format("DD.MM.YYYY") ?? "?"}</PrevVersion>
                  </VersionRow>
                  <VersionRow>
                    <PrevVersion>{t("legals.admin.effective_date")}:</PrevVersion>
                    <PrevVersion>{moment(selectedDocument.dateEffective).format("DD.MM.YYYY") ?? "?"}</PrevVersion>
                  </VersionRow>
                  {selectedDocument?.previousVersions?.map((d) => {
                    const link = `/legals/view/${d.name}/${d.version}`;
                    return (
                      <VersionRow>
                        <PrevVersion>{t("legals.admin.previous_version")}:</PrevVersion>
                        <PrevVersion>
                          <ExternalLink to={link} target="_blank" title="Предыдущая версия документа">
                            {window.location.origin + link}
                          </ExternalLink>
                        </PrevVersion>
                      </VersionRow>
                    )
                  })}
                </FlexBox>
              )}
            </DocumentContent>
          </LegalBlocksNew>
        )}
      </DocumentWrapper>
    </TiptapContainer>
  );
};
export default LegalsPage;
import { useEffect, useMemo, useRef, useState } from "react";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { useLocation, useParams, useHistory } from "react-router-dom";
import { AppTester, getCurrentAppName, getCurrentContextName } from "../../../supporting";
import { ExternalLink, FlexBox, useBreakpoint } from "@brg/ui";
import useQueryState from "shared/hooks/useQueryState";
import { API, Endpoints } from "@brg/api";
import {
  Arrow,
  LegalBlocksNew,
  LegalBlocks,
  Routes,
  Tab,
  PrevVersion,
  TiptapContainer,
  DocumentContent,
  LegalsHeader,
  DocumentWrapper,
  LegalsSubHeader,
  VersionRow
} from "./styles";
import VerticalNavigationArray from "shared/pages/LegalsPage/VerticalNavigationArray";
import moment from "moment";
import { LayoutConst } from "core";
import { BackButton } from "./styles";
import { ReactComponent as BackIcon } from "./icons/back.svg";
import { getTitle } from './documentHelper';
import { getText } from './documentHelper';

const LegalsPage = (props: any) => {

  const { t, i18n: { language } } = useTranslation();

  const theme = useTheme();
  const [target, setTarget] = useState<string | undefined>("");

  const history = useHistory();
  const location = useLocation();
  const isMobile = useBreakpoint(LayoutConst.screen.s);

  const [documents, setDocuments] = useState<ILegalDocument[]>([]);
  const [selectedDocument, setSelectedDocument] = useState<ILegalDocument | null>(null);

  const appName = getCurrentAppName();
  const contextName = AppTester.isMediiia() && !AppTester.isMediiiaMain() && !AppTester.isLectureMediiia()
    ? 'mediiia'
    : getCurrentContextName();

  const { name } = useParams<{ name: string }>();

  useEffect(() => {
    if (documents && (name || !isMobile)) {
      const d = documents.find((d) => d.name?.toLowerCase() === name?.toLowerCase()) ?? documents.find(d => !d.link) ?? null
      setSelectedDocument(d);
      setTarget(getTitle(d?.title, language) ?? getTitle(documents.at(0)?.title, language));
    }
  }, [name, documents, location, isMobile]);

  useEffect(() => {
    if (appName && contextName) {
      API.request()
        .endpoint(Endpoints.legal)
        .url("/api/Document/GetLegalDocuments")
        .get()
        .addQuery("appName", appName)
        .addQuery("contextName", contextName)
        .send()
        .then((r) => r.json())
        .then((r) => {
          if (r.length > 0) {
            setDocuments(r);
            if (!isMobile) {
              setSelectedDocument(r[0]);
            }
          }
        })
        .catch((e) => console.error(e));
    }
  }, [appName, contextName]);

  const onDocumentSelected = (doc: NavItem) => {
    if (doc.link) {
      window.open(`${doc.link}`, "_blank");
      return;
    }

    setTarget(getTitle(doc.title, language));
    setSelectedDocument(doc);
  };

  const onBackClick = () => {
    history.push("/legals");
    setSelectedDocument(null);
  };

  const shouldHideDocument = isMobile && !name;
  const shouldHideNavigation = isMobile && name;

  return (
    <TiptapContainer directionMobile="column">
      <DocumentWrapper>
        {!shouldHideNavigation && (
          <>
            {isMobile && <LegalsHeader>{t("legals.index")}</LegalsHeader>}
            <Tab theme={theme}>
              <VerticalNavigationArray
                items={documents}
                currentlySelectedKey={selectedDocument?.name}
                getKeyProp={(item) => item.name}
                getDisplayProp={(item) => getTitle(item.title, language)}
                onClick={onDocumentSelected}
              />
            </Tab>
          </>
        )}
        {!shouldHideDocument && (
          <LegalBlocksNew theme={theme}>
            {isMobile && (
              <BackButton onClick={onBackClick}>
                <BackIcon />
                <span>
                  {t("legals.all_documents")}
                </span>
              </BackButton>
            )}
            <DocumentContent dangerouslySetInnerHTML={{ __html: getText(selectedDocument?.text, language) ?? '' }} />
            <DocumentContent>
              {selectedDocument?.previousVersions?.[0] && (
                <FlexBox direction="column">
                  {/* <LegalsHeader>{t("legals.admin.version_history")}</LegalsHeader> */}
                  <LegalsSubHeader>{t("legals.admin.previous_versions")}</LegalsSubHeader>
                  <VersionRow>
                    <PrevVersion>{t("legals.admin.version_date")}:</PrevVersion>
                    <PrevVersion>{moment(selectedDocument.datePublished).format("DD.MM.YYYY") ?? "?"}</PrevVersion>
                  </VersionRow>
                  <VersionRow>
                    <PrevVersion>{t("legals.admin.effective_date")}:</PrevVersion>
                    <PrevVersion>{moment(selectedDocument.dateEffective).format("DD.MM.YYYY") ?? "?"}</PrevVersion>
                  </VersionRow>
                  {selectedDocument?.previousVersions?.map((d) => {
                    const link = `/legals/view/${d.name}/${d.version}`;
                    return (
                      <VersionRow>
                        <PrevVersion>{t("legals.admin.previous_version")}:</PrevVersion>
                        <PrevVersion>
                          <ExternalLink to={link} target="_blank" title="Предыдущая версия документа">
                            {window.location.origin + link}
                          </ExternalLink>
                        </PrevVersion>
                      </VersionRow>
                    )
                  })}
                </FlexBox>
              )}
            </DocumentContent>
          </LegalBlocksNew>
        )}
      </DocumentWrapper>
    </TiptapContainer>
  );
};
export default LegalsPage;
